
// console.log("CAO - ");
document.addEventListener('DOMContentLoaded', () => {
  const MAX_RETRIES = 20;
  let retries = 0;

  const openCartDrawer = () => {
    const drawer = document.querySelector('.hs-sticky-cart-cart-drawer a');
    if (drawer) {
      drawer.click();
      // console.log('Cart drawer opened');
    } else if (retries < MAX_RETRIES) {
      retries++;
      setTimeout(openCartDrawer, 200);
    } else {
      // console.warn('Cart drawer not found after max retries');
    }
  };

  // const triggerShopliftTest = async () => {
  //   try {
  //     // if (window.shoplift 
  //     //   // && typeof window.shoplift.isHypothesisActive === 'function'
  //     // ) {
  //         // let v2IsBucketed;
  //         // let v2IsBucketed = await window.shoplift.isHypothesisActive('7934bd20-59d6-4e10-b0f8-20a339bca3ae');
  //         // let v2IsBucketedTestID = await window.shoplift.isHypothesisActive('974ba1f0-cc29-422c-b6d5-b618858ee7a8'); // testIDTest

  //         // const v1IsBucketed = await window.shoplift.isHypothesisActive('957634b9-9bda-47e1-bef9-4cdf964f9ff4');
  //         // setTimeout(() => {
  //         //   window.shoplift.isHypothesisActive('7934bd20-59d6-4e10-b0f8-20a339bca3ae')
  //         //     .then(v2IsBucketed => {
  //         //       // use isv2IsBucketed here
  //         //       console.log("isv2IsBucketed here:", v2IsBucketed);
  //         //     })
  //         //     .catch(error => {
  //         //       console.error('Error checking hypothesis:', error);
  //         //     });

  //         //   window.shoplift.isHypothesisActive('957634b9-9bda-47e1-bef9-4cdf964f9ff4')
  //         //     .then(v1IsBucketed => {
  //         //       // use v1IsBucketed here
  //         //       console.log("v1IsBucketed here", v1IsBucketed);
  //         //     })
  //         //     .catch(error => {
  //         //       console.error('Error checking hypothesis:', error);
  //         //     });


  //         // }, 5000);
  //         // console.log('Shoplift test bucket v2 result:', v2IsBucketed);
  //         // console.log('Shoplift test bucket v1 result:', v1IsBucketed);
  
  //         // if (v2IsBucketed ) {
  //         //   console.log('User is bucketed into Variant 2');
  //           sessionStorage.setItem('cartDrawerShown', 'true');
  //           openCartDrawer();
  //         // } else {
  //         //   console.log('User is in control group');
  //         // }


  //     // } else {
  //     //   console.warn('Shoplift API not available');
  //     // }
  //   } catch (error) {
  //     // console.error('Error triggering Shoplift test:', error);
  //   }
  // };

  if (!sessionStorage.getItem('cartDrawerShown')) {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        if (cart.items && cart.items.length > 0) {
          setTimeout(() => {
            try {
              sessionStorage.setItem('cartDrawerShown', 'true');
              openCartDrawer();
            } catch (error) {
              // console.error('Error triggering Shoplift test:', error);
            }
          }, 10000);
        } else {
          // console.log('Cart is empty — no test triggered');
        }
      })
      .catch((err) => console.error('Error fetching cart:', err));
  } else {
    // console.log("CAO ---");
  }
});
